export default __webpack_public_path__ + "static/media/troubleshoot-icon.ba6af231.svg";